function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M295.068,573.938c.027-.777-.5-1.065-1.253-1.15a4.742,4.742,0,0,1-4.68-4.718c-.069-.667-.393-1.1-1.1-1.117s-1.049.429-1.146,1.076c-.056.371-.044.756-.134,1.118a4.8,4.8,0,0,1-4.5,3.639c-.733.08-1.246.311-1.3,1.132A1.071,1.071,0,0,0,282,574.979c3.159.409,4.5,1.7,4.877,4.707.088.693.423,1.185,1.164,1.161s1.047-.5,1.1-1.215A4.759,4.759,0,0,1,293.818,575C294.544,574.939,295.043,574.655,295.068,573.938Z",
  transform: "translate(-280.956 -554.026)",
  fill: "#2898de"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M332.371,609.385a2.569,2.569,0,0,1-2.515-2.454c-.071-.391-.172-.682-.631-.667-.414.013-.533.306-.571.648a2.575,2.575,0,0,1-2.578,2.482.568.568,0,0,0-.59.53.557.557,0,0,0,.579.629,2.575,2.575,0,0,1,2.6,2.55.574.574,0,0,0,.623.594.563.563,0,0,0,.553-.569,2.59,2.59,0,0,1,2.586-2.571c.359-.033.609-.213.6-.617C332.994,609.54,332.732,609.448,332.371,609.385Z",
  transform: "translate(-313.495 -582.914)",
  fill: "#2898de"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M421.38,598.291l-11.153,10.984a1.18,1.18,0,0,0,0,1.687,1.225,1.225,0,0,0,1.713,0l11.153-10.984a1.18,1.18,0,0,0,0-1.687A1.226,1.226,0,0,0,421.38,598.291Z",
  transform: "translate(-375.162 -576.799)",
  fill: "#2898de"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M435.593,626.2l-4.113,4.051a1.18,1.18,0,0,0,0,1.687,1.224,1.224,0,0,0,1.713,0l4.114-4.051a1.18,1.18,0,0,0,0-1.687A1.226,1.226,0,0,0,435.593,626.2Z",
  transform: "translate(-390.693 -597.306)",
  fill: "#2898de"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M403.233,518.2H379.7a4.276,4.276,0,0,0-4.3,4.238V569.1a4.2,4.2,0,0,0,.943,2.645v.171h.146a4.324,4.324,0,0,0,3.214,1.421h23.535a4.323,4.323,0,0,0,3.214-1.422h.147v-.17a4.2,4.2,0,0,0,.942-2.645V522.442A4.276,4.276,0,0,0,403.233,518.2Zm-14.874,3.033a.72.72,0,0,1,.532-.186c1.632-.031,3.35-.033,5.106-.007a.8.8,0,0,1,.569.19.508.508,0,0,1,.118.393c-.015.257-.12.52-.778.52h0l-2.416,0H390.6c-.555,0-1.111,0-1.666,0-.639-.006-.671-.355-.683-.487A.528.528,0,0,1,388.36,521.237Zm-10.542,1.515a2.038,2.038,0,0,1,1.88-2.161h2.081a.479.479,0,0,1,.441.508,3.643,3.643,0,0,0,3.361,3.864h11.893a3.507,3.507,0,0,0,3.236-3.72V521.1a.479.479,0,0,1,.441-.508h2.081a2.038,2.038,0,0,1,1.88,2.162v45.633a2.626,2.626,0,0,1-2.646,2.606h-22a2.626,2.626,0,0,1-2.646-2.606Z",
  transform: "translate(-349.968 -518.204)",
  fill: "#2898de"
});

function SvgIconSmartPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.569,
    height: 55.13,
    viewBox: "0 0 57.569 55.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmartPhone);
export default __webpack_public_path__ + "static/media/icon_smart_phone.5fa8dff7fa3e9e615b23a31f0e7869b0.svg";
export { ForwardRef as ReactComponent };